var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tmenu"},[_c('div',{staticClass:"wsize"},[_c('ul',{staticClass:"sitelink"},_vm._l((_vm.topLinkList),function(item,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(_vm.$sanitize(item.content))},on:{"click":function($event){return _vm.openWindow(item.url)}}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }